import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screenshots-page',
  templateUrl: './screenshots-page.component.html',
  styleUrls: ['./screenshots-page.component.scss']
})
export class ScreenshotsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
